import { createRouter, createWebHistory } from 'vue-router'
import Home from '../components/Home.vue'
import DIY from '../components/DIY.vue'
import Login from '../components/login/Login.vue'
import Card from '../components/voc/Card.vue'
import BindStudent from '../components/admin/TeacherBindStudent.vue'
import StudentTest from '../components/voc/test/index.vue'
import TestItem from '../components/voc/test/TestItem.vue'
import NewTestItem from '../components/voc/test/NewTestItem.vue'
import NewTestItemResult from '../components/voc/test/NewTestItemResult.vue'
import AssignToStudent from '../components/voc/vip/AssignToStudent.vue'
import StudentVocPracticeList from '../components/voc/vip/StudentVocPracticeList.vue'
import StudentVocPracticeItem from '../components/voc/vip/StudentVocPracticeItem.vue'
import CheckStudentAssignment from '../components/voc/vip/CheckStudentAssignment.vue'
import StudentVocNirvanaItem from '../components/voc/vip/StudentVocNirvanaItem.vue'
import StudentOverview from '../components/voc/studentoverview/index.vue'
import StudentSubjectOverview from '../components/voc/studentoverview/subject.vue'
import RecordingCard from '../components/voc/recordtotest/RecordingCard.vue'
import AudioTestItem from '../components/voc/test/AudioTestItem.vue'
import AudioTestItemResult from '../components/voc/test/AudioTestItemResult.vue'
import Plan from '../components/voc/plan/index.vue'
import Speaking from '../components/voc/speaking/Speaking.vue'
import vocTyper from '../components/voc/typer/Index.vue'
import WordCloze from '../components/voc/cloze/Index.vue'
import ClozeList from '../components/voc/cloze/ClozeList.vue'
import ClozeResult from '../components/voc/cloze/ClozeResult.vue'
import ClozeAssignmentList from '../components/voc/cloze/ClozeAssignmentList.vue'
import WordCompletion from '../components/voc/completion/Index.vue'
import CompletionList from '../components/voc/completion/CompletionList.vue'
import CompletionResult from '../components/voc/completion/CompletionResult.vue'
import CompletionAssignmentList from '../components/voc/completion/CompletionAssignmentList.vue'
import TeacherAssignTypingPractice from '../components/voc/typer/TeacherAssignTypingPractice.vue'
import TeacherTypingStudentAssignments from '../components/voc/typer/TeacherTypingStudentAssignments.vue'
import StudentMyTypingAssignments from '../components/voc/typer/StudentMyTypingAssignments.vue'
import TyperAddSample from '../components/voc/typer/TyperAddSample.vue'
import PronunciationEvaluator from '../components/voc/recordtotest/PronunciationEvaluator.vue'
import SpeakEnglishTestItem from '../components/voc/test/SpeakEnglishTestItem.vue'
import SpeakEnglishTestItemResult from '../components/voc/test/SpeakEnglishTestItemResult.vue'
import TestReport from '../components/voc/test/TestReport.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Andover Vocabulary - Home'
    }
  },
  {
    path: '/DIY',
    name: 'DIY',
    component: DIY,
    meta: {
      title: 'Andover Vocabulary - DIY'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/card',
    name: 'Card',
    component: Card,
    meta: {
      title: 'Andover Vocabulary - 单词卡'
    }
  },
  {
    path: '/bindstudent',
    name: 'BindStudent',
    component: BindStudent
  },
  {
    path: '/studenttest',
    name: 'StudentTest',
    component: StudentTest
  },
  {
    path: '/testreport',
    name: 'TestReport',
    component: TestReport
  },
  {
    path: '/testitem',
    name: 'TestItem',
    component: TestItem
  },
  {
    path: '/newtestitem',
    name: 'NewTestItem',
    component: NewTestItem
  },
  {
    path: '/newtestitemresult',
    name: 'NewTestItemResult',
    component: NewTestItemResult
  },
  {
    path: '/assigntostudent',
    name: 'AssignToStudent',
    component: AssignToStudent
  },
  {
    path: '/vPracticeList',
    name: 'StudentVocPracticeList',
    component: StudentVocPracticeList
  },
  {
    path: '/vPracticeItem',
    name: 'StudentVocPracticeItem',
    component: StudentVocPracticeItem
  },
  {
    path: '/checkstudentassignment',
    name: 'CheckStudentAssignment',
    component: CheckStudentAssignment
  },
  {
    path: '/vNirvanaItem',
    name: 'StudentVocNirvanaItem',
    component: StudentVocNirvanaItem
  },
  {
    path: '/studentOverview',
    name: 'StudentOverview',
    component: StudentOverview
  },
  {
    path: '/studentSubjectOverview',
    name: 'StudentSubjectOverview',
    component: StudentSubjectOverview
  },
  {
    path: '/recordingcard',
    name: 'RecordingCard',
    component: RecordingCard
  },
  {
    path: '/audiotestitem',
    name: 'AudioTestItem',
    component: AudioTestItem
  },
  {
    path: '/audiotestitemresult',
    name: 'AudioTestItemResult',
    component: AudioTestItemResult
  },
  {
    path: '/plan',
    name: 'Plan',
    component: Plan
  },
  {
    path: '/speaking',
    name: 'Speaking',
    component: Speaking
  },
  {
    path: '/vocTyper',
    name: 'VocTyper',
    component: vocTyper
  },
  {
    path: '/wordCloze',
    name: 'WordCloze',
    component: WordCloze,
    meta: {
      title: 'Andover Vocabulary - 选词填空'
    }
  },
  {
    path: '/studentcloze',
    name: 'ClozeList',
    component: ClozeList,
    meta: {
      title: 'Andover Vocabulary - Cloze'
    }
  },
  {
    path: '/studentclozeresult',
    name: 'ClozeResult',
    component: ClozeResult,
    meta: {
      title: 'Andover Vocabulary - Cloze 结果'
    }
  },
  {
    path: '/clozeassignment',
    name: 'ClozeAssignmentList',
    component: ClozeAssignmentList,
    meta: {
      title: 'Andover Vocabulary - Assignment'
    }
  },
  {
    path: '/wordBlank',
    name: 'WordCompletion',
    component: WordCompletion,
    meta: {
      title: 'Andover Vocabulary - 完形填空'
    }
  },
  {
    path: '/studentblank',
    name: 'CompletionList',
    component: CompletionList,
    meta: {
      title: 'Andover Vocabulary - Blank'
    }
  },
  {
    path: '/studentblankresult',
    name: 'CompletionResult',
    component: CompletionResult,
    meta: {
      title: 'Andover Vocabulary - Blank 结果'
    }
  },
  {
    path: '/blankassignment',
    name: 'CompletionAssignmentList',
    component: CompletionAssignmentList,
    meta: {
      title: 'Andover Vocabulary - Blank HW'
    }
  },
  {
    path: '/vocTyper/teacher-assign',
    name: 'VocTyperTeacherAssign',
    component: TeacherAssignTypingPractice,
    meta: {
      title: 'Andover Vocabulary - 布置打字练习'
    }
  },
  {
    path: '/vocTyper/student-assignments',
    name: 'VocTyperStudentAssignments',
    component: TeacherTypingStudentAssignments,
    meta: {
      title: 'Andover Vocabulary - 学生打字作业'
    }
  },
  {
    path: '/vocTyper/my-assignments',
    name: 'VocTyperMyAssignments',
    component: StudentMyTypingAssignments,
    meta: {
      title: 'Andover Vocabulary - 我的打字作业'
    }
  },
  {
    path: '/vocTyper/add-sample',
    name: 'VocTyperAddSample',
    component: TyperAddSample,
    meta: {
      title: 'Andover Vocabulary - 添加打字样本'
    }
  },
  {
    path: '/pronunciation-evaluator',
    name: 'PronunciationEvaluator',
    component: PronunciationEvaluator
  },
  {
    path: '/speakenglishtestitem',
    name: 'SpeakEnglishTestItem',
    component: SpeakEnglishTestItem
  },
  {
    path: '/speakenglishtestitemresult',
    name: 'SpeakEnglishTestItemResult',
    component: SpeakEnglishTestItemResult
  }
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
